import { render, staticRenderFns } from "./DownloadInfoNew.vue?vue&type=template&id=08e349a2&scoped=true&"
import script from "./DownloadInfoNew.vue?vue&type=script&lang=js&"
export * from "./DownloadInfoNew.vue?vue&type=script&lang=js&"
import style0 from "./DownloadInfoNew.vue?vue&type=style&index=0&id=08e349a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e349a2",
  null
  
)

export default component.exports